// extracted by mini-css-extract-plugin
export default {"administer_medicine_form":"AdministerMedicineForm_administer_medicine_form__OqyfK"};